import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'ugc-radio',
  styleUrl: 'ugc-radio.scss',
  shadow: false,
})
export class UgcRadio {
  @Prop() name: string = '';
  @Prop() checked: boolean = false;
  @Prop() content: any;
  @Prop() value: string = '';
  @Prop() disabled: boolean = false;
  @Prop() radioChange: (value) => {};

  handleRadio({ target: { value = '' } }) {
    this.radioChange(value);
  }

  render() {
    return (
      <div class="ugc-radio-wrapper">
        <label class="container py-8 plr-36">
          {this.content}
          <input
            type="radio"
            name={this.name}
            checked={this.checked}
            value={this.value}
            disabled={this.disabled}
            onChange={this.handleRadio.bind(this)}
          />
          <span class="check-mark" />
        </label>
      </div>
    );
  }
}
